
// src/helpers/component-id.js

import React from 'react'

export default function(Component) {
  class IdComponent extends React.Component {
    componentId = Math.random().toString().slice(-12)

    render() {
      return <Component {...this.props} componentId={this.componentId} />
    }
  }

  IdComponent.displayName = `ComponentId(${Component.displayName})`
  return IdComponent
}



// WEBPACK FOOTER //
// ./src/helpers/component-id.js